import React, { Component } from 'react';
import Hero from './components/Hero';
import Header from './components/Header';
import Footer from './components/Footer';
import BannerNotice from './components/BannerNotice';
import Home from './views/Home';
import Funding from './views/Funding';  
import Applications from './views/Applications';  
import Contact from './views/Contact';
import Leadership from "./views/Leadership";
import Testimonials from "./views/Testimonials";
import ReactGA from "react-ga4";

ReactGA.initialize("G-E46EWN0MXQ");

class App extends Component {
  render() {
    if (window.location.pathname === '/applications') {
      return (
        <div className="App">
          <BannerNotice />
          <Header />
          <Applications />
          <Footer />
        </div>
      );
    }
    else if (window.location.pathname === '/contact') {
      return (
        <div className="App">
            <BannerNotice />
          <Header />
          <Contact />
          <Footer />
        </div>
      );
    }
    else if (window.location.pathname === '/funding') {
      return (
        <div className="App">
            <BannerNotice />
          <Header />
          <Funding />
          <Footer />
        </div>
      );
    }
    else if (window.location.pathname === '/leadership') {
      return (
        <div className="App">
            <BannerNotice />
          <Header />
          <Leadership />
          <Footer />
        </div>
      );
    }
    else if (window.location.pathname === '/testimonials') {
      return (
        <div className="App">
            <BannerNotice />
          <Header />
          <Testimonials />
          <Footer />
        </div>
      );
    }
    else {
      return (
        <div className="App">
            <BannerNotice />
          <Hero />
          <Home />
          <Footer />
        </div>
      );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js